import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-blue-950 text-white" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjq3rk0ux0x6" />
      <main data-id="element-2" data-mp="3mj6j3vjtnyfg">
        <Hero data-id="element-3" data-mp="3rcj5s04xxv5k" />
        <SocialProof data-id="element-4" data-mp="3rbrcivytg9ig" />
        <Testimonials data-id="element-5" data-mp="3rdkisa5iorpx" />
        <ProblemSection data-id="element-6" data-mp="3rd18nfm3z7mg" />
        <SystemSection data-id="element-7" data-mp="5yimri0b7dt" />
        <ModulesSection data-id="element-8" data-mp="67z9oh5w26u" />
        <BonusSection data-id="element-9" data-mp="4n725ibkvc5" />
        <UrgencySection data-id="element-10" data-mp="82kz509bybz" />
        <PricingSection data-id="element-11" data-mp="2zl3dbpgpde7f" />
        <MoreResults data-id="element-12" data-mp="2zlv8x0aavbxp" />
        <GuaranteeSection data-id="element-13" data-mp="2zmo4r67q0h12" />
        <FAQ data-id="element-14" data-mp="2zn678kkz7rhf" />
        <ClosingSection data-id="element-15" data-mp="33movnqc0akp0" />
        <SummaryTable data-id="element-16" data-mp="33lwyib2rgewm" />
        <FinalCta data-id="element-17" data-mp="33ngfy505kvzz" />
      </main>
      <Footer data-id="element-18" data-mp="33oi337ug18y2" />
      <PurchaseNotification data-id="element-19" data-mp="38lrpsfqg76i7" />
    </div>;
}